import caseConstants from "@/config/constants/caseConstants";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    };
  },
  computed: {
    ...mapGetters("profile", ["getTestPanelsData"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("hospitals", ["getSingleHospital"]),
  },
  methods: {
    checkHospitalHasEmailNotifications(caseType) {
      if (
        this.getSingleHospital &&
        this.getSingleHospital.settings &&
        this.getSingleHospital.settings.patient_report_settings &&
        this.getSingleHospital.settings.patient_report_settings
          .send_finalized_report_to_patient &&
        this.getSingleHospital.settings.patient_report_settings
          .email_sending_data &&
        this.getSingleHospital.settings.patient_report_settings
          .email_sending_data.status
      ) {
        let hasAccess =
          this.getSingleHospital &&
          this.getSingleHospital.settings &&
          this.getSingleHospital.settings.patient_report_settings &&
          this.getSingleHospital.settings.patient_report_settings
            .send_finalized_report_to_patient &&
          this.getSingleHospital.settings.patient_report_settings
            .email_sending_data &&
          this.getSingleHospital.settings.patient_report_settings
            .email_sending_data.status;
        if (hasAccess) {
          let hasCaseTypeRestriction =
            this.getSingleHospital.settings.patient_report_settings
              .email_sending_data.for_all_case_types;
          if (hasAccess && hasCaseTypeRestriction) {
            return true;
          } else if (hasAccess && !hasCaseTypeRestriction) {
            let emailCaseTypes =
              this.getSingleHospital.settings.patient_report_settings
                .email_sending_data.for_specific_case_types;
            if (emailCaseTypes.indexOf(caseType) > -1) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    checkHospitalHasSmsNotifications(caseType) {
      if (
        this.getSingleHospital &&
        this.getSingleHospital.settings &&
        this.getSingleHospital.settings.patient_report_settings &&
        this.getSingleHospital.settings.patient_report_settings
          .send_finalized_report_to_patient &&
        this.getSingleHospital.settings.patient_report_settings
          .sms_sending_data &&
        this.getSingleHospital.settings.patient_report_settings.sms_sending_data
          .status
      ) {
        let hasAccess =
          this.getSingleHospital &&
          this.getSingleHospital.settings &&
          this.getSingleHospital.settings.patient_report_settings &&
          this.getSingleHospital.settings.patient_report_settings
            .send_finalized_report_to_patient &&
          this.getSingleHospital.settings.patient_report_settings
            .sms_sending_data &&
          this.getSingleHospital.settings.patient_report_settings
            .sms_sending_data.status;

        if (hasAccess) {
          let hasCaseTypeRestriction =
            this.getSingleHospital.settings.patient_report_settings
              .sms_sending_data.for_all_case_types;
          if (hasAccess && hasCaseTypeRestriction) {
            return true;
          } else if (hasAccess && !hasCaseTypeRestriction) {
            let smsCaseTypes =
              this.getSingleHospital.settings.patient_report_settings
                .sms_sending_data.for_specific_case_types;
            if (smsCaseTypes.indexOf(caseType) > -1) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    caseTypesText(caseTypes) {
      return caseTypes
        .map((type) => this.caseTypeMap[type])
        .join(", ")
        .toUpperCase();
    },
    getFormattedValues(params) {
      for (let [key, value] in Object.entries(params)) {
        if (!value) {
          delete params[key];
        }
      }
      return params;
    },
    getUserBasedCaseTypes(caseTypes = []) {
      if (
        Array.isArray(this.getAuthenticatedUser?.allowed_case_types) &&
        this.getAuthenticatedUser.allowed_case_types.length
      ) {
        const data = this.getAuthenticatedUser.allowed_case_types;
        return caseTypes.filter(caseType => data.includes(caseType.value));
      }
      return caseTypes;
    },
    
    getLabBasedCaseTypes(caseTypes = []) {
      if (Array.isArray(this.getTestPanelsData) && this.getTestPanelsData.length) {
        const data = this.getTestPanelsData.map(e => e.code);
        return caseTypes.filter(caseType => data.includes(caseType.value));
      }
      return caseTypes;
    },    
  },
};
